/**
 * CHG-052: 프로젝트 사용 가능 이슈 타입 조회 훅
 */
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/axios';
import { registerProjectIssueTypes } from '../constants/issueTypeConfig';

export interface ProjectIssueType {
  issueTypeId: string;
  name: string;
  icon: string;
  color: string;
  customIconPath?: string | null;  // CHG-053: 커스텀 아이콘 경로
  isDefault: boolean;
  allowedChildTypes: { issueTypeId: string; name: string; icon: string }[];
  canBeRoot: boolean;
}

interface ProjectIssueTypesResponse {
  schemeId: string;
  schemeName: string;
  issueTypes: ProjectIssueType[];
}

export const projectIssueTypeKeys = {
  all: (projectId: string) => ['projectIssueTypes', projectId] as const,
};

export function useProjectIssueTypes(projectId: string) {
  const query = useQuery({
    queryKey: projectIssueTypeKeys.all(projectId),
    queryFn: async (): Promise<ProjectIssueTypesResponse> => {
      const { data } = await api.get(`/projects/${projectId}/issue-types`);
      return data.data;
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5분 캐시
  });

  // 데이터 로드 시 글로벌 레지스트리에 자동 등록
  useEffect(() => {
    if (query.data?.issueTypes) {
      registerProjectIssueTypes(
        query.data.issueTypes.map((t) => ({
          issueTypeId: t.issueTypeId,
          name: t.name,
          icon: t.icon,
          color: t.color,
          customIconPath: (t as any).customIconPath ?? undefined,
        })),
      );
    }
  }, [query.data]);

  return query;
}
